import React, { createContext, useContext, ReactNode } from 'react';
import {
  useRegistrationForm,
  UseRegistrationFormReturn,
} from '../hooks/useRegistrationForm';

// ✅ USAR EL TIPO DE RETORNO DEL HOOK
type RegistrationContextType = UseRegistrationFormReturn;

const RegistrationContext = createContext<RegistrationContextType | undefined>(
  undefined
);

interface RegistrationProviderProps {
  children: ReactNode;
}

export const RegistrationProvider: React.FC<RegistrationProviderProps> = ({
  children,
}) => {
  const registrationForm = useRegistrationForm();

  return (
    <RegistrationContext.Provider value={registrationForm}>
      {children}
    </RegistrationContext.Provider>
  );
};

export const useRegistrationContext = () => {
  const context = useContext(RegistrationContext);
  if (context === undefined) {
    throw new Error(
      'useRegistrationContext must be used within a RegistrationProvider'
    );
  }
  return context;
};
